import { Link } from "react-router-dom";
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatCurrency } from "../../../../Utils/formatters";

interface SubAccountItem {
  subAccountId: string;
  name: string;
  idCustomer: string;
  isActive: boolean;
  available: number;
}

interface OrganizerListTableProps {
  data: SubAccountItem[];
  canNavigate?: boolean;
  emptyMessage?: string;
  highlight?: string;
}

export default function OrganizerListTable({ data, canNavigate, emptyMessage, highlight }: OrganizerListTableProps) {
  const normalize = (v: string) =>
    (v || "").toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  const highlightText = (text?: string) => {
    const query = highlight || "";
    if (!text || !query) return text;
    const normText = normalize(text);
    const normQuery = normalize(query);
    if (!normQuery) return text;

    const parts: Array<string | JSX.Element> = [];
    let start = 0;
    let idx = normText.indexOf(normQuery, start);
    while (idx !== -1) {
      if (idx > start) parts.push(text.slice(start, idx));
      const end = idx + normQuery.length;
      parts.push(
        <mark key={`${idx}-${end}`} style={{ background: '#fff3bf', padding: 0 }}>
          {text.slice(idx, end)}
        </mark>
      );
      start = end;
      idx = normText.indexOf(normQuery, start);
    }
    if (start < text.length) parts.push(text.slice(start));
    return <>{parts}</>;
  };
  return (
    <TableContainer component={Paper}>
      <Table size="small" aria-label="lista de organizadores">
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell>ID do cliente</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="right">Saldo disponível</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(!data || data.length === 0) && (
            <TableRow>
              <TableCell colSpan={4}>{emptyMessage || 'Nenhum organizador cadastrado.'}</TableCell>
            </TableRow>
          )}
          {Array.isArray(data) && data.map((row) => (
            <TableRow key={row.subAccountId} hover>
              <TableCell>
                {canNavigate ? (
                  <Link to={`/pontos-de-venda/${row.subAccountId}`}> 
                    <Typography color="primary">{highlightText(row.name)}</Typography>
                  </Link>
                ) : (
                  <Typography>{highlightText(row.name)}</Typography>
                )}
              </TableCell>
              <TableCell>{highlightText(row.idCustomer)}</TableCell>
              <TableCell align="center">
                {row.isActive ? (
                  <Chip label="Ativo" color="success" size="small" />
                ) : (
                  <Chip label="Inativo" color="error" size="small" variant="outlined" />
                )}
              </TableCell>
              <TableCell align="right">{formatCurrency(row.available)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
